import * as React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl/FormControl';
import {ExtendedWrappedFieldProps, FormField} from '../FormFields';
import Input, {ExtendedInputProps} from '@material-ui/core/Input';
import {NumberFormatProps} from 'react-number-format';
import {Omit} from '@material-ui/core';
import {WrappedFieldInputProps} from 'redux-form';

const NumberFormat = require('react-number-format'); // we use require since react-number-format only exports default, so using import doesn't work

export type FormInputProps = ExtendedWrappedFieldProps & ExtendedInputProps & {numberFormatProps?: NumberFormatProps};
const FormInput: React.FunctionComponent<FormInputProps> = ({
  instructionText,
  explanationText,
  input,
  showErrors,
  formHelperText,
  meta: {error, touched},
  numberFormatProps,
  disabledTooltip,
  ...props
}) => {
  return (
    <FormField
      error={error}
      showErrors={showErrors}
      touched={touched}
      explanationText={explanationText}
      instructionText={instructionText}
      formHelperText={formHelperText}
      fieldName={input ? input.name : undefined}
      disabledTooltip={props.disabled ? disabledTooltip : undefined}
    >
      {numberFormatProps ? (
        <NumberFormat
          customInput={FormInputInner}
          error={error}
          showErrors={showErrors}
          touched={touched}
          {...props}
          {...numberFormatProps}
          {...input}
        />
      ) : (
        <FormInputInner error={error} showErrors={showErrors} touched={touched} {...props} {...input} />
      )}
    </FormField>
  );
};

export default FormInput;

const FormInputInner = React.forwardRef<
  any,
  WrappedFieldInputProps & Omit<FormInputProps, 'input' | 'meta' | 'numberFormatProps'>
>(({fullWidth, label, error, showErrors, touched, ...props}, ref) => {
  return (
    <FormControl fullWidth={fullWidth}>
      {label ? (
        <InputLabel shrink={props.units && props.units['position'] === 'start' ? true : undefined}>{label}</InputLabel>
      ) : (
        undefined
      )}
      <Input fullWidth error={error && (showErrors || touched)} inputRef={ref} {...props} />
    </FormControl>
  );
});
